import { apiFetch } from "./http";

export type AuthSession = {
  token: string;
  expiresAt: number;
  user: { id: string; nickname: string; avatarUrl?: string | null };
};

export async function registerAccount(username: string, password: string) {
  return apiFetch<AuthSession>("/api/v1/auth/register", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
}

export async function loginWithPassword(username: string, password: string) {
  return apiFetch<AuthSession>("/api/v1/auth/login", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
}

export async function changePassword(token: string, currentPassword: string, newPassword: string) {
  return apiFetch<{ ok: true; otherSessionsRevoked: true }>("/api/v1/me/password", {
    method: "POST",
    headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
}

export async function revokeAllSessions(token: string) {
  return apiFetch<{ ok: true; revokedSessions: number }>("/api/v1/me/sessions", {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}

export async function updatePublicProfile(
  token: string,
  input: { nickname: string; avatarUrl?: string },
) {
  return apiFetch<{ user: AuthSession["user"] }>("/api/v1/me", {
    method: "PATCH",
    headers: { "content-type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(input),
  });
}

export async function deleteAccount(token: string) {
  return apiFetch<{ ok: true; storageCleanupPending: number }>("/api/v1/me", {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
}
